<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-md-8">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <span class="section-title">
                {{ transport.id === 0 ? 'Crear' : 'Editar' }} Transporte
              </span>
              <argon-button color="warning" size="sm" class="ms-auto" @click="save">
                Guardar
              </argon-button>
            </div>
          </div>
          <div class="card-body">
            <div class="row">

              <!-- Fecha de Transporte -->
              <div class="col-md-6">
                <label class="form-control-label">Fecha de transporte</label>
                <argon-input type="date" v-model="transport.transport_date" />
              </div>

              <!-- Vehículo (mayúsculas automáticas) -->
              <div class="col-md-6">
                <label class="form-control-label">Vehículo</label>
                <argon-input
                  type="text"
                  :model-value="transport.vehicle"
                  @update:model-value="transport.vehicle = ($event || '').toUpperCase()"
                />
              </div>

              <!-- Conductor (mismo estilo de letra que los demás inputs) -->
              <div class="col-md-6 conductor-select-wrapper">
                <label class="form-control-label">Conductor</label>
                <select ref="driverSelect" class="form-control" v-model="transport.driver_name">
                  <option value="" disabled>Seleccione un conductor</option>
                  <option v-for="user in users" :key="user.id" :value="user.name">
                    {{ user.name }}
                  </option>
                </select>
              </div>


              <!-- Costo -->
              <div class="col-md-6">
                <label class="form-control-label">Costo de transporte</label>
                <argon-input type="number" step="0.01" v-model="transport.transport_cost" />
              </div>

              <!-- 
                  NO hay un campo de input para "mines_extractions_id" 
                  porque se recibe siempre vía Prop (ver script).
                -->

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

function getTodayBogota() {
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Bogota',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
  return formatter.format(new Date()); // ej: 2026-03-02
}
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'select2/dist/css/select2.min.css';
import 'select2';

export default {
  name: "MinesExtractionsTransport",

  // Data
  data() {
    return {
      transport: {
        id: 0,
        mines_extractions_id: '',
        transport_date: '',
        vehicle: '',
        driver_name: '',
        transport_cost: ''
      },
      form: {
        id: 0,
        mines_extractions_id: '',
        name: '',
        location: '',
        extraction_date: '',
        extracted_quantity: '',
        equipment_used: '',
        worker: '',
        quality: '',
        humidity: '',
        notes: ''
      },
      users: [],

    };
  },
  components: {
    ArgonInput,
    ArgonButton,
  },
  methods: {
    async loadTransport(id) {
      try {
        const response = await this.$store.dispatch("minesExtractionsTransport/getData", id);
        this.transport = { ...this.transport, ...response.data };
      } catch (error) {
        console.error("Error al cargar:", error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo cargar la información.',
        });
      }
    },

    async save() {
      try {
        if (!this.transport.transport_date || !this.transport.vehicle || !this.transport.driver_name || Number(this.transport.transport_cost) <= 0) {
          Swal.fire({
            icon: 'warning',
            title: 'Advertencia',
            text: 'Completa todos los campos antes de guardar.',
          });
          return;
        }
        const response = await this.$store.dispatch("minesExtractionsTransport/save", this.transport);
        if (response && response.status >= 200 && response.status < 300) {
          Swal.fire({
            icon: 'success',
            title: 'Éxito',
            text: `Transporte ${this.transport.id === 0 ? 'creado' : 'actualizado'} correctamente`,
            confirmButtonText: 'Aceptar',
          }).then(() => {
            // Redirige a Create en la pestaña Transporte
            this.$router.push({
              name: 'Extraction Create',
              params: {
                id: this.transport.mines_extractions_id,
                data: JSON.stringify(this.form)
              },
              query: { tab: 1 }
            });
          });
        } else {
          throw new Error(response?.data?.message || 'Ocurrió un error');
        }
      } catch (error) {
        console.error("Error al guardar:", error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el transporte',
        });
      }
    },

    async getUsers() {
      const response = await this.$store.dispatch("users/getAll")
      this.users = response
    },

    //Cargar datos de la pestaña 1
    async getDataExtraction() {
      const id = this.transport.mines_extractions_id;
      if (!id) {
        console.error('El id mines_extractions_id no está definido.');
        return;
      }
      try {
        // Suponiendo que la acción espera un id primitivo
        const response = await this.$store.dispatch("minesExtractions/getData", id);
        this.form = { ...this.form, ...response.data };
      } catch (error) {
        console.error("Error fetching get data:", error);
      }
    },

  },
  mounted() {
    const data = this.$route.params.data;
    if (data) {
      try {
        const params = JSON.parse(data);
        if (params.id > 0) {
          this.transport = { ...this.transport, ...params };
        } else {
          this.transport.mines_extractions_id = params.mines_extractions_id;
          // Crear nuevo: fecha de transporte = hoy
          if (!this.transport.transport_date) {
            this.transport.transport_date = getTodayBogota();
          }
        }
      } catch (error) {
        console.error("Error al parsear datos:", error);
      }
    }
    // Si es registro nuevo y aún no hay fecha, usar hoy
    if (!this.transport.transport_date && this.transport.id === 0) {
      this.transport.transport_date = getTodayBogota();
    }

    this.getDataExtraction();
    this.loadTransport(this.transport.id);

    // Cargar usuarios para el select
    this.getUsers()

    // Inicializar Select2 en el campo ref="driverSelect"
    $(this.$refs.driverSelect).select2({
      containerCssClass: 'select2-conductor-input',
      dropdownCssClass: 'select2-dropdown-conductor',
    })

    // Escuchar cambios para mantener v-model sincronizado
    $(this.$refs.driverSelect).on('change', () => {
      this.transport.driver_name = $(this.$refs.driverSelect).val()
    })

    // setNavPills, setTooltip, etc.
    setNavPills();
    setTooltip();
  },
};
</script>

<style scoped>
.section-title {
  font-weight: 800;
  color: #1f2d5a;
  letter-spacing: 0.6px;
}

.section-title::after {
  content: "";
  display: block;
  width: 44px;
  height: 3px;
  margin-top: 6px;
  border-radius: 999px;
  background: #f6a500;
}

/* Conductor: mismo tamaño y estilo de letra que Fecha, Vehículo, Costo */
:deep(.conductor-select-wrapper .select2-container) {
  font-size: 0.875rem !important;
}
:deep(.conductor-select-wrapper .select2-selection__rendered),
:deep(.conductor-select-wrapper .select2-selection__placeholder) {
  font-size: 0.875rem !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
}
:deep(.conductor-select-wrapper .select2-selection__placeholder) {
  color: #6c757d !important;
}
</style>

<!-- Lista desplegable Conductor (Select2 se pinta en body): mismo tamaño de letra -->
<style>
.select2-dropdown-conductor .select2-results__option {
  font-size: 0.875rem !important;
  font-weight: 400 !important;
}
</style>